import { render } from "./UserCarrinho.vue?vue&type=template&id=4812461a&scoped=true"
import script from "./UserCarrinho.vue?vue&type=script&lang=js"
export * from "./UserCarrinho.vue?vue&type=script&lang=js"

import "./UserCarrinho.vue?vue&type=style&index=0&id=4812461a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\musta\\Área de Trabalho\\Projetos\\catalogo\\catalogo-pedidos\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4812461a"]])

export default __exports__